<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="usuario" class="col-sm-offset-1 col-sm-1 control-label">IP / DNS:</label>
            <div class="col-sm-3">
                <input type="text" v-model="config.ip" class="form-control" id="usuario">
            </div>
            <label for="senha" class="col-sm-1 control-label">PORTA</label>
            <div class="col-sm-2">
                <input type="text" v-model="config.porta"  class="form-control" id="senha" >
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-4">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>

            <div class="col-sm-4">

            </div>
            <div class="col-sm-2">

                <div class="dropup">
                    <button class="btn btn-xs btn-block btn-default dropdown-toggle" type="button" id="dropdownMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i class="fa fa-list-alt"></i> AÇÕES
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuList">
                        <li>
                            <button @click="sendAll()" type="button" class="btn btn-xs btn-success">
                                <i class="fa fa-save"></i> ENVIAR COMANDOS PARA TODOS
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
    import {RST} from "../../../../class";
    import {Bus} from '../../../../class/bus';
    export default {
        name: "ApnConcox",
        props: {
            config: {
                "default": null
            },
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await RST.sendIpPorta(this.id_rastreador, this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.log(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            },
            sendAll () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração para todos?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await RST.sendIpPortaAll(this.id_rastreador, this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
